import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ResultListItem from "../../result_list/ResultListItem";
import TestDuration from "../../../partial/TestDuration";
import withUrlParams from "../../../HOC/withUrlParams";
import i18n from 'i18next';

const useStyles = makeStyles({
    button: {
        '&$selected, &$selected:hover, &:hover': {
            backgroundColor: "transparent"
        }
    },
    card: {
        display: "flex", flexDirection: "column", padding: 10
    }
});

const MyTests = () => {
    const classes = useStyles();

    return (
        <Card square className={classes.card}>
            <ResultListItem disableRipple button disableGutters>
                <Typography variant="h5" component="h2">
                    {i18n.t('my_test_type')}:
                </Typography>
            </ResultListItem>
            <React.Fragment>
                <Typography variant="body2" align="left">
                    {i18n.t('test_result')}: 10/10 (100%)
                </Typography>
                <TestDuration startTime={null}
                              endTime={null}
                              align={"left"}/>
            </React.Fragment>
        </Card>
    );
};

export default withUrlParams(MyTests);